// extracted by mini-css-extract-plugin
export default {"container":"About_container__-dJwL"};